
import { Users } from "lucide-react";
import { format } from "date-fns";
import { FamilyProfileDialog } from "@/components/FamilyProfileDialog";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface SiblingsInfoSectionProps {
  familyProfile: any;
  onProfileUpdate?: () => void;
}

export function SiblingsInfoSection({ familyProfile, onProfileUpdate }: SiblingsInfoSectionProps) {
  const { language } = useLanguage();

  const formatDate = (date: Date) => {
    if (language === 'ja') {
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    }
    return format(date, "MMMM d, yyyy");
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold flex items-center">
        <Users className="h-5 w-5 mr-2 text-blue-500" />
        {t('family.siblings', language)}
      </h3>
      
      {familyProfile && familyProfile.siblings && familyProfile.siblings.length > 0 ? (
        <div className="space-y-2">
          {familyProfile.siblings.map((sibling: any) => (
            <div key={sibling.id} className="border-b pb-2 mb-2">
              <div className="flex justify-between">
                <span className="text-muted-foreground">{language === 'ja' ? '名前:' : 'Name:'}</span>
                <span className="font-medium">{sibling.name}</span>
              </div>
              
              {sibling.birthday && (
                <div className="flex justify-between mt-1">
                  <span className="text-muted-foreground">{language === 'ja' ? '誕生日:' : 'Birthday:'}</span>
                  <span className="font-medium">{formatDate(new Date(sibling.birthday))}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center p-4 border border-dashed rounded-lg">
          <p className="text-muted-foreground mb-2">
            {language === 'ja' ? '兄弟姉妹はまだ追加されていません' : 'No siblings added yet'}
          </p>
          <FamilyProfileDialog onComplete={onProfileUpdate} />
        </div>
      )}
    </div>
  );
}
